var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocalLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3477_36922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 30.375C38.25 30.996 37.746 31.5 37.125 31.5H16.875C16.254 31.5 15.75 30.996 15.75 30.375C15.75 29.754 16.254 29.25 16.875 29.25H37.125C37.746 29.25 38.25 29.754 38.25 30.375ZM30.375 38.25H16.875C16.254 38.25 15.75 38.754 15.75 39.375C15.75 39.996 16.254 40.5 16.875 40.5H30.375C30.996 40.5 31.5 39.996 31.5 39.375C31.5 38.754 30.996 38.25 30.375 38.25ZM49.5 22.4662V43.875C49.5 49.4572 44.9572 54 39.375 54H14.625C9.04275 54 4.5 49.4572 4.5 43.875V10.125C4.5 4.54275 9.04275 0 14.625 0H27.0338C30.9375 0 34.6117 1.521 37.377 4.284L45.216 12.1252C47.979 14.886 49.5 18.558 49.5 22.4662ZM35.784 5.8725C34.5443 4.635 33.084 3.71475 31.5 3.10275V14.6228C31.5 16.4835 33.0142 17.9977 34.875 17.9977H46.3973C45.783 16.4137 44.8628 14.9512 43.6253 13.7137L35.784 5.8725ZM47.25 22.4662C47.25 21.7125 47.1645 20.9745 47.034 20.25H34.875C31.7722 20.25 29.25 17.7255 29.25 14.625V2.466C28.5233 2.3355 27.7853 2.25 27.0338 2.25H14.625C10.2825 2.25 6.75 5.7825 6.75 10.125V43.875C6.75 48.2175 10.2825 51.75 14.625 51.75H39.375C43.7175 51.75 47.25 48.2175 47.25 43.875V22.4662Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3477_36922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalLang);
export default __webpack_public_path__ + "static/media/local-lang.9a48b305af1c619f640bf3cf5a6946e7.svg";
export { ForwardRef as ReactComponent };